import { useState } from 'react';
import _ from 'lodash';

const useTableSelectionState = (keys, rows) => {

  const [state, setState] = useState(rows);

  const setSelectedRows = (selected, clearSelected, selectedRows) => {

    const sr = _.without(selectedRows, undefined);

    setState(s => {

      if(sr.length === 0) return [];

      let cs = clearSelected ? [] : s;

      if(selected) {
        return _.uniqBy([
          ...cs,
          ...sr.map(o => {

            let obj = {};

            for(let i = 0; i < keys.length; i++) {
              obj[keys[i]] = o[keys[i]]
            };

            return obj;
          })
        ], keys[0])
      }
      else {
        return _.filter(s, oo => !_.includes(_.map(sr, keys[0]), oo[keys[0]]));
      }
    })
  };

  return [state, setSelectedRows];
}

export default useTableSelectionState;